export default __webpack_public_path__ + "static/media/regulatory--no-construction-vehicles--g1.28ffa65d.png";